import React from 'react';
import { useTranslation } from 'react-i18next';

function RadioControl() {
  const { t } = useTranslation('common');

  return (
    <div className="d-flex align-items-center">
      <p className="custom-radio">
        <input type="radio" id="status_0" name="status" checked="checked" />
        <label htmlFor="status_0">{t('RADIO_OPTION.RADIO_1')}</label>
      </p>
      <p className="custom-radio ml-4">
        <input type="radio" id="status_1" name="status" />
        <label htmlFor="status_1">{t('RADIO_OPTION.RADIO_2')}</label>
      </p>
    </div>
  );
}

export default RadioControl;
